import { message } from 'antd';
import { deleteWithCSRF } from './axiosWithCSRF';
import { envApiUrl } from './envApiUrl';

export const deleteFile = async (id: number, refetch?: () => void) => {
  if (!id) return;

  try {
    const response = await deleteWithCSRF(envApiUrl + '/files/' + id);
    console.log('deleteFile: response: ', response);
    message.success('Successfully deleted file');
    refetch?.();
    return response.data;
  } catch (err: any) {
    console.error('deleteFile error: ', err.response?.data?.message, err);
    message.error(err.response?.data?.message || 'Failed to delete file');
  }
};
